import { memo } from "react";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { DesignMagazineRoomArticleI18nEditContainer } from "./container";

type Props = {
	hotelID: string;
	roomID: string;
	langCode: LangCode;
};

export const DesignMagazineRoomArticleI18nEdit = memo(({ hotelID, roomID, langCode }: Props) => {
	return <DesignMagazineRoomArticleI18nEditContainer hotelID={hotelID} roomID={roomID} langCode={langCode} />;
});

DesignMagazineRoomArticleI18nEdit.displayName = "DesignMagazineRoomArticleI18nEdit";
